import React from 'react'

import { Col, Form } from '_zari/core'

const MontoLetrasFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='MONTO LETRAS' htmlFor='input-suma-montoLetras' md={12} />
      <Col md={12}>
        <Form.InputNumber id='input-suma-montoLetras' name='input-suma-montoLetras' disabled value={iValue} onChange={() => {}} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoLetrasFormGroup)
